import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getDataTableByFormIDAndFeatureID,
    initDataTableStandAloneEditor
} from "@/helpers/datatable/datatable-standalone-editor-helper";

export class LayerInfoInfoItemMutationStandaloneRemoveComponent extends HTMLElement {
    constructor(){
        super();
        const template = document.createElement('template');
        const formID = this.getAttribute('data-form-id')
        const featureID = this.getAttribute('data-feature-id')
        const linked = this.getAttribute('data-linked')

        template.innerHTML = `<button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header mr-1" href="#">
          <span class="fa fa-trash"></span>
          <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
             Verwijder object
            <div class="arrow" data-popper-arrow=""></div>
          </div>
        </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            let isLinked = false
            if(linked === 'true') {
                isLinked = true
            }

            initDataTableStandAloneEditor(getDataTableByFormIDAndFeatureID(formID, featureID), 'remove', isLinked)
        })
    }
}
